module.exports = __webpack_public_path__ + "static/img/banner.514cb6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/australia_a_league/banner.png
// module id = jRtv
// module chunks = 1